import {TooltipProps} from 'recharts';

import {SourcingVehicleResponseBody} from '@dms/api/core';

import {Nullish, TestIdProps} from 'shared/web';

import {PriceMapChartItem} from '../types/PriceMapChartItem';
import {SourcingVehicleMapTooltipCard} from './SourcingVehicleMapTooltipCard';

export function ChartTooltip(
  // TooltipProps comes from recharts
  // eslint-disable-next-line -eslint/no-explicit-any
  props: TooltipProps<any, any> & {
    mySourcingVehicle: SourcingVehicleResponseBody;
  } & TestIdProps
) {
  const payload: PriceMapChartItem | Nullish = props.payload?.[0]?.payload;

  return (
    <SourcingVehicleMapTooltipCard
      externalId={payload?.car.ad_id}
      comparisonVehicle={props.mySourcingVehicle}
      data-testid={props['data-testid']}
    />
  );
}
